<div class="flex flex-col items-center justify-center min-h-screen gap-6">
  <app-icon-badge content="icons/maintenance.svg" backgroundColor="transparent" [size]="128" [iconSize]="128" />
  <h1 class="text-4xl font-bold text-center">{{ 'pages.maintenance.title' | translate }}</h1>
  <p class="text-xl text-center">
    {{ 'pages.maintenance.description' | translate }}
  </p>

  <button mat-fab type="button" class="mat-secondary-transparent-button-color" (click)="navigateToDashboard()">
    @if (isLoading()) {
      <app-dots-spinner />
    } @else {
      <app-icon src="icons/rotate-360.svg" alt="refresh" class="scale-x-[-1]" />
    }
  </button>
</div>
